import Project from "./Project";

const CV = () => {
    return (
        <Project path="markdowns/cv.md"></Project>
    )
}
export default CV